// extracted by mini-css-extract-plugin
export default {"stickyComponent":"cQZJLiSoBGmidWb6xRS4","stick":"_SLimGob6sbmMr23l29k"};